import React, { useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Activity, CheckCircle2, XCircle, AlertCircle } from 'lucide-react';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const status = searchParams.get('status');
  const message = searchParams.get('message');

  const content = useMemo(() => {
    if (status === 'success') {
      return {
        icon: <CheckCircle2 className="w-16 h-16 text-emerald-500" />,
        title: 'E-mail Verificado!',
        description: 'Seu e-mail foi verificado com sucesso. Agora você pode fazer login na plataforma.',
        bg: 'bg-emerald-50',
        border: 'border-emerald-200',
      };
    }
    if (status === 'already') {
      return {
        icon: <AlertCircle className="w-16 h-16 text-amber-500" />,
        title: 'E-mail Já Verificado',
        description: message || 'Seu e-mail já foi verificado anteriormente. Faça login normalmente.',
        bg: 'bg-amber-50',
        border: 'border-amber-200',
      };
    }
    return {
      icon: <XCircle className="w-16 h-16 text-red-500" />,
      title: 'Erro na Verificação',
      description: message || 'O link de verificação é inválido ou já foi utilizado.',
      bg: 'bg-red-50',
      border: 'border-red-200',
    };
  }, [status, message]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Activity className="w-7 h-7 text-blue-600" />
            <span className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Chivo, sans-serif' }}>Vital</span>
          </div>
        </div>

        <div className={`${content.bg} border ${content.border} rounded-2xl p-8 text-center`}>
          <div className="flex justify-center mb-4">
            {content.icon}
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-3" style={{ fontFamily: 'Chivo, sans-serif' }} data-testid="verify-email-title">
            {content.title}
          </h1>
          <p className="text-slate-600 mb-6" data-testid="verify-email-description">
            {content.description}
          </p>
          <Button
            onClick={() => navigate('/')}
            data-testid="verify-email-go-login"
            className="bg-slate-900 hover:bg-slate-800 text-white px-8"
          >
            Ir para Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
